var map = {
	"./Kvartalsrapport Q1 2024.pdf": 2432,
	"./Kvartalsrapport Q1 2025.pdf": 38,
	"./Kvartalsrapport Q1 2026.pdf": 448,
	"./Kvartalsrapport Q2 2024.pdf": 5456,
	"./Kvartalsrapport Q2 2025.pdf": 8664,
	"./Kvartalsrapport Q2 2026.pdf": 9040,
	"./Kvartalsrapport Q3 2024.pdf": 280,
	"./Kvartalsrapport Q3 2025.pdf": 2544,
	"./Kvartalsrapport Q3 2026.pdf": 480,
	"./Kvartalsrapport Q4 2023.pdf": 3568,
	"./Kvartalsrapport Q4 2024.pdf": 8672,
	"./Kvartalsrapport Q4 2025.pdf": 970,
	"./Årsrapport 2022.pdf": 4600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4796;